import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {PurchaseOrderNumberModule} from '@app/checkout/checkout-purchase-order-number/purchase-order-number.module';
import {DcpCheckoutOrderSummaryModule} from '@app/checkout/dcp-checkout-order-summary/dcp-checkout-order-summary.module';
import {DcpCheckoutPlaceOrderModule} from '@app/checkout/dcp-checkout-place-order/dcp-checkout-place-order.module';
import {PaymentModule} from '@app/payment/payment.module';
import {DcpCartCouponModule} from '@app/shared/coupon/dcp-cart-coupon.module';
import {I18nModule, UrlModule} from '@spartacus/core';
import {SummaryComponent} from './summary.component';

import {GroupSkipDirective} from '@dcp/accessibility';
import '@udex/web-components/dist/Tile.js';

@NgModule({
  declarations: [SummaryComponent],
  imports: [
    CommonModule,
    DcpCartCouponModule,
    DcpCheckoutOrderSummaryModule,
    PurchaseOrderNumberModule,
    DcpCheckoutPlaceOrderModule,
    UrlModule,
    RouterModule,
    I18nModule,
    PaymentModule,
    GroupSkipDirective,
  ],
  exports: [SummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SummaryModule {}
